'use client'

import Section, { SectionProps } from '@lyra/core/components/Section'
import { PageId } from '@lyra/web/constants/pages'
import YieldTable from '@lyra/web/containers/common/YieldTable'
import { getPagePath } from '@lyra/web/utils/pages'
import { useRouter } from 'next/navigation'
import React from 'react'

import YieldSummaryItems from '../yield/YieldSummaryItems'

type Props = SectionProps

export default function HomeYieldSection({ ...sectionProps }: Props) {
  const router = useRouter()
  return (
    <Section {...sectionProps}>
      <Section.Header
        title="Vaults"
        subtitle="Grow your crypto with vaults that execute automated options strategies"
        onPressTitle={() => router.push(getPagePath({ page: PageId.Earn }))}
      />
      <Section.XStack>
        <YieldSummaryItems />
      </Section.XStack>
      <Section.Table>
        <YieldTable />
      </Section.Table>
    </Section>
  )
}
